const booth_date_info = [
  [1, 2, 3, 4, 5, 6, 7],
  [1, 2, 3, 8, 9, 6, 7],
  [1, 2, 3, 8, 9, 4, 5],
];

export default booth_date_info;
